import React, { createContext, useContext, useEffect, useState } from 'react';
import { Socket, io } from 'socket.io-client';
import { CONFIG } from 'src/config-global';
import { STORAGE_KEY } from 'src/auth/context/jwt/constant';
import { useAuthContext } from 'src/auth/hooks';

interface WebSocketContextProps {
  socket: Socket | null;
}

export const WebSocketContext = createContext<WebSocketContextProps>({ socket: null });

export const useWebSocket = () => {
  return useContext(WebSocketContext);
};

export const WebSocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { authenticated } = useAuthContext();
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    // Chỉ khởi tạo Socket khi user đã authenticated (đăng nhập)
    if (authenticated) {
      const token = localStorage.getItem(STORAGE_KEY);
      if (token) {
        const newSocket = io(CONFIG.site.serverUrl, {
          query: { token },
          transports: ['websocket'],
          reconnectionAttempts: 5,
        });

        let heartbeatInterval: NodeJS.Timeout;

        newSocket.on('connect', () => {
          console.log('Socket connected successfully');
          // Gửi heartbeat định kỳ mỗi 15 giây
          heartbeatInterval = setInterval(() => {
            if (newSocket.connected) {
              newSocket.emit('heartbeat', { ping: true });
            }
          }, 15000);
        });

        newSocket.on('disconnect', () => {
          console.log('Socket disconnected');
          clearInterval(heartbeatInterval);
        });

        setSocket(newSocket);

        // Cleanup: ngắt kết nối khi component unmount hoặc logout
        return () => {
          clearInterval(heartbeatInterval);
          newSocket.disconnect();
          setSocket(null);
        };
      }
    } else {
      // Đảm bảo ngắt kết nối nếu mất auth state
      if (socket) {
        socket.disconnect();
        setSocket(null);
      }
    }
  }, [authenticated]);

  return (
    <WebSocketContext.Provider value={{ socket }}>
      {children}
    </WebSocketContext.Provider>
  );
};
